import styled from '@emotion/styled';
import { Box } from '@mui/material';

import { getColor } from '../../common/UICommon';

import { TabletWidth } from '../../../global.style';
import { MobileOrderSummaryHeight } from '../../common/PaymentSummary/MobilePaymentSummary.style';
import { ContainerBox } from '../../styledComponent/Boxes.style';
import { ContentCol, TwoSidedLayout } from '../../common/v2/TwoSidedLayout/TwoSidedLayout.style';

export const PaymentPageTwoSidedLayout = styled(TwoSidedLayout)`
  @media (max-width: ${TabletWidth}px) {
    padding-top: ${MobileOrderSummaryHeight}px;
  }
`;

export const SpecialOfferTitle = styled.p`
  font-weight: 600;
  margin-top: 12px;
`;

export const PaymentContainerBox = styled(ContainerBox)`
  margin-bottom: 32px;
`;

export const Benefits = styled(Box)`
  background-color: #faf5ff;
  padding: 40px 32px 0;
  color: ${getColor('BLACK_60')};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`;

export const H5 = styled.h5`
  font-weight: 600;
  color: ${getColor('BLACK')};
  margin-bottom: 4px;
`;

export const LeftCol = styled(ContentCol)`
  flex-direction: column;
  align-items: center;
`;

export const PaymentSummaryCol = styled(ContentCol)`
  background-color: ${getColor('LIGHT_CREAM')};
  min-height: 100vh;

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const PaymentSecurityBoxWrapper = styled.div`
  margin-top: 48px;
`;
